import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: ` <div class="text-center">
    <img
      [attr.src]="coppaIcon"
      enTooltip
      data-toggle="tooltip"
      [attr.title]="coppaText"
    />
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoppaAudienceComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input()
  data: MobileAppPtiRanking;

  coppaText: string;
  coppaIcon: string;

  ngOnInit(): void {
    switch (this.data?.coppaAudience) {
      case 'Child Directed':
        this.coppaIcon = '/assets/images/icon-child-audience.svg';
        this.coppaText = 'Likely child-directed';
        break;
      case 'General Audience':
        this.coppaIcon = '/assets/images/icon-general-audience.svg';
        this.coppaText = 'Likely general audience';
        break;
      default:
        this.coppaIcon = '';
        this.coppaText = '';
        break;
    }
  }
}
